import React, { Component } from 'react';
import Datas from '../../data/shop/mondiya/product.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/mondiya/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/mondiya/Breadcrumb';
import FooterTwo from '../../components/mondiya/FooterTwo';
import { Styles } from './styles/mondiya/product.js';
import { withTranslation } from 'react-i18next';

class Product extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: [],
            redirectToCategory: false,
        };
    }

    componentDidMount() {
        const category = this.props.match.params.category;
        this.filterProducts(category);
    }

    componentDidUpdate(prevProps) {
        const prevCategory = prevProps.match.params.category;
        const currentCategory = this.props.match.params.category;

        if (prevCategory !== currentCategory) {
            this.filterProducts(currentCategory);
        }
    }

    filterProducts(category) {
        const filteredData = Datas.filter((product) => product.category === category && product.status === "1");

        if (filteredData.length === 0) {
            console.log("No products found for this category with status 1");
            this.setState({ redirectToCategory: true });
        } else {
            this.setState({ filteredData });
        }
    }

    render() {
        const { filteredData, redirectToCategory } = this.state;
        const { t } = this.props;

        if (redirectToCategory) {
            this.props.history.push(`${process.env.PUBLIC_URL}/product-category`);
            window.location.reload();
        }

        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper product-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title={t('shop.productCategory.breadcrumbs2')} />

                    {/* Products */}
                    <section className="product-area">
                        <Container>
                            <Row>
                                <Col lg="12" md="12" sm="12">
                                    <Row>
                                        <Col lg="12" md="12" className="product-top-navbar">
                                            {filteredData.length > 0 && (
                                                <nav className="navbar navbar-dark bg-dark">
                                                    <span className="navbar-brand mb-0 h1">
                                                        <Link to={`${process.env.PUBLIC_URL}/`} className="product-link">{t('shop.home')}</Link> > <Link to={`${process.env.PUBLIC_URL}/product-category`} className="product-link">{t('shop.product')}</Link> > <span className="product-text">{t(`shop.productCategory.categories.${filteredData[0].category}`)}</span>
                                                    </span>
                                                </nav>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row>
                                        {filteredData.length > 0 ? (
                                                filteredData.map((data, i) => (
                                            <Col lg="3" md="6" key={i}>
                                                <div className="product-box">
                                                <div className="product-img">
                                                        <img src={process.env.PUBLIC_URL + `/assets/images/${data.productImg}`} alt="" className="img-fluid" />
                                                        <div className="layer-box"></div>
                                                        <Link className="item_view" to={process.env.PUBLIC_URL + data.productUrl}>{t('shop.productCategory.view_item')}</Link>
                                                    </div>
                                                    <div className="product-content text-center">
                                                        <div className="pro-title">
                                                            <h5><Link to={process.env.PUBLIC_URL + data.productUrl}>{data.productTitle}</Link></h5>
                                                        </div>
                                                        <div className="pro-price">
                                                            <p>{data.anotherName}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                                ))
                                            ) : (
                                                <p>No products found for this category.</p>
                                            )}
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default withTranslation()(Product);